import type { TimelineItem } from "@/mocks/articles";

type Props = {
  items: TimelineItem[];
};

export default function ArticleTimeline({ items }: Props) {
  return (
    <ol className="relative mt-6 space-y-6 border-l border-background-300 pl-6">
      {items.map((item) => (
        <li key={item.at} className="relative">
          <span
            className="absolute -left-[31px] top-1 h-2.5 w-2.5 rounded-full border-2 border-background-50 bg-accent-500"
            aria-hidden="true"
          ></span>
          <p className="font-heading text-sm font-semibold text-foreground-900">{item.at}</p>
          <p className="mt-1 text-sm leading-relaxed text-foreground-600">{item.text}</p>
        </li>
      ))}
    </ol>
  );
}